import { useState, useEffect, useCallback } from 'react'
import { GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia } from '@services/PlanoAcao/Index'
import { GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia } from '@services/Relatorio/Index'

// Hook para buscar relatórios e planos de ação de um processo + unidade
export function useFetchDataByProcessoUnidade(idProcesso, idUnidadeGerencia) {
  const [relatorios, setRelatorios] = useState([])
  const [planosAcao, setPlanosAcao] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // parâmetros fixos conforme solicitado
  const pageNumber = 1
  const pageSize = 100

  const fetchAll = useCallback(async () => {
    if (!idProcesso || !idUnidadeGerencia) return

    setLoading(true)
    setError(null)

    try {
      const [planosRes, relRes] = await Promise.all([
        GetAllPlanosAcaoByIdProcessoAndIdUnidadeGerencia(
          pageNumber,
          pageSize,
          idProcesso,
          idUnidadeGerencia
        ),
        GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia(
          pageNumber,
          pageSize,
          idProcesso,
          idUnidadeGerencia
        )
      ])

      const novosPlanos = planosRes.items || []
      const novosRelatorios = relRes.items || []

      setPlanosAcao(novosPlanos);
      setRelatorios(novosRelatorios);

      return {
        relatorios: novosRelatorios,
        planosAcao: novosPlanos
      }
    } catch (err) {
      console.error('Erro ao buscar documentos:', err)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [idProcesso, idUnidadeGerencia])

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  return {
    relatorios,
    planosAcao,
    loadingDocs: loading,
    errorDocs: error,
    refetchDocs: fetchAll
  }
}
